import { Link } from "wouter";
import { Button } from "../components/ui/Button";
import { Cloud, Star } from "../components/decor";

export function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-sky-50 via-white to-white px-6 text-center">
      {/* Static decor — every decor SVG is aria-hidden internally. */}
      <Cloud className="absolute left-[10%] top-20 w-28" />
      <Cloud className="absolute right-[12%] top-36 w-20 opacity-70" />
      <Star className="absolute bottom-24 left-[16%] w-6 text-amber-300" />
      <Star className="absolute right-[20%] top-28 w-4 text-sky-300" />
      <p className="font-display text-7xl font-bold text-sky-600">404</p>
      <h1 className="mt-3 font-display text-2xl font-bold tracking-tight text-neutral-900 sm:text-3xl">
        Page not found
      </h1>
      <p className="mt-2 max-w-sm text-sm text-neutral-600">
        The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved.
      </p>
      <Button asChild className="mt-8">
        <Link href="/">Back to home</Link>
      </Button>
    </div>
  );
}
